export enum Direction {
  RIGHT = 'right',
  LEFT = 'left',
}

export type DirectionType = Direction.LEFT | Direction.RIGHT;
